/* eslint-disable */
// @ts-nocheck
import React from "react";
import { Col, UiBox, UiTabPanel } from "~/components/elements";

const styles = `
  .earn-money-container {
    transition: opacity ease-in 0.2s;
    // background: #ECEFF6;
    font-family: "Lato", "Helvetica Neue", Arial, sans-serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.75;
    color: #3D4D5F;
    -webkit-font-smoothing: antialiased;
    cursor: pointer;
  }

  .earn-money-container * {
    box-sizing: border-box;
  }

  .container-xl {
    width: 100%;
    padding: 0 1rem;
    margin: 0 auto;
    // background-color: rgba(255, 255, 255, 0.5);
  }

  @media (min-width: 1200px) {
    .container-xl {
      max-width: 1440px;
    }
  }

  .row {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -0.75rem;
  }

  .col-lg-6 {
    width: 100%;
    padding: 0 0.75rem;
  }

  @media (min-width: 992px) {
    .col-lg-6 {
      flex: 0 0 auto;
      width: 50%;
    }
    .offset-lg-3 {
      margin-left: 25%;
    }
  }

  .text-center {
    text-align: center;
  }

  .h3 {
    font-size: 1.75rem;
    margin: 0 0 0.25rem 0;
    font-weight: 900;
    line-height: 1.2;
    color: #3D4D5F;
  }

  .text-gray-700 {
    color: #60748A;
  }

  .text-md {
    font-size: 1rem;
    line-height: 1.75;
  }

  .fw-normal {
    font-weight: 400;
  }

  .mt-2 {
    margin-top: 0.5rem;
  }

  .mt-3 {
    margin-top: 1rem;
  }
  .mt-6 {
    margin-top: 3rem;
  }

  .mb-0 {
    margin-bottom: 0;
  }

  .mb-1 {
    margin-bottom: 0.25rem;
  }

  .mb-3 {
    margin-bottom: 1rem;
  }

  .mb-5 {
    margin-bottom: 3rem;
  }

  .panel {
    border-radius: 0.5rem;
    box-shadow: 0 1px 2px #D4DDE7, 0 4px 12px 0px #D4DDE7;
    background: white;
    padding: 3rem;
  }

  .affiliate-welcome-text {
    text-align: center;
  }

  .text-gray-800 {
    color: #3D4D5F;
  }

  .gray-link {
    color: #60748A;
    text-decoration: underline;
  }

  .gray-link:hover {
    color: #152332;
  }

  .my-4 {
    margin: 1.5rem 0;
  }

  .form-label {
    display: inline-block;
    margin-bottom: 0.5rem;
    font-weight: 700;
    color: #3D4D5F;
    font-size: 0.875rem;
  }

  .form-control {
    display: block;
    width: 100%;
    padding: 0.5rem 1rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.75;
    color: #3D4D5F;
    // background-color: #f5f5f5;
    border: 1px solid #D4DDE7;
    border-radius: 10px;
    pointer-events: none;
  }

  .form-text {
    margin-top: 0.25rem;
    font-size: 0.875em;
    color: rgba(61, 77, 95, 0.75);
  }

  .btn {
    display: inline-block;
    padding: 0.5rem 1.5rem;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.75;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    vertical-align: middle;
    border: 1px solid transparent;
    border-radius: 10px;
    opacity: 0.65;
    pointer-events: none;
  }

  .btn-primary {
    color: #FFFFFF;
    background-color: #1884FF;
    border-color: #1884FF;
  }

  .d-grid {
    display: grid;
  }

  .honeypot {
    display: none;
  }

  .after-panel {
    color: #3D4D5F;
    margin-top: 1rem;
    margin-bottom: 3rem;
    text-align: center;
  }

  .after-panel a {
    color: #3D4D5F;
    text-decoration: none;
    pointer-events: none;
  }

  .d-flex {
    display: flex;
  }

  .align-items-center {
    align-items: center;
  }

  .justify-content-center {
    justify-content: center;
  }

  .text-sm {
    font-size: 0.875rem;
    line-height: 1.5;
  }
`;

export const EarnMoneyTabPanel: React.FC = () => {
  const handleContainerClick = () => {
    window.open(
      "https://bettershot.getrewardful.com/signup?utm_source=bettershot&utm_medium=app&utm_campaign=user_affiliate_signup",
      "_blank"
    );
  };

  return (
    <UiTabPanel>
      <UiBox className="w-full h-full" overflow="auto">
        <style dangerouslySetInnerHTML={{ __html: styles }} />
        <UiBox className="earn-money-container" onClick={handleContainerClick}>
          <UiBox className="container-xl">
            <Col className="row" align="center">
              <UiBox
                w={{ base: "100%", md: "70%" }}
                // className="col-lg-6 offset-lg-3"
              >
                <div className="text-center mt-6">
                  <h1 className="h3 mb-1">Refer & Earn Money</h1>
                  <h2 className="text-gray-700 text-md fw-normal mt-2 mb-0">
                    Earn 50% commission for every new customer you refer to Bettershot.
                  </h2>
                  <h2 className="text-gray-700 text-md fw-normal mt-0">Sign up below</h2>
                </div>

                <div className="panel mt-3">
                  <div className="affiliate-welcome-text text-center">
                    <strong className="text-gray-800">Join Friends of Bettershot - 50%</strong> and receive a 50%
                    commission on all payments for paying customers you refer to{" "}
                    <span className="gray-link">bettershot.ai</span>!
                  </div>

                  <hr className="my-4" />

                  <div>
                    <div className="mb-3">
                      <label className="form-label" htmlFor="firstName">
                        First name
                      </label>
                      <input
                        placeholder="Luke"
                        className="form-control"
                        type="text"
                        name="firstName"
                        id="firstName"
                        value=""
                        readOnly
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label" htmlFor="lastName">
                        Last name
                      </label>
                      <input
                        placeholder="Skywalker"
                        className="form-control"
                        type="text"
                        name="lastName"
                        id="lastName"
                        value=""
                        readOnly
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label" htmlFor="email">
                        Email
                      </label>
                      <input
                        placeholder="luke@jedi.com"
                        className="form-control"
                        type="email"
                        name="email"
                        id="email"
                        value=""
                        readOnly
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label" htmlFor="password">
                        Password
                      </label>
                      <input
                        placeholder="hunter2"
                        className="form-control"
                        type="password"
                        name="password"
                        id="password"
                        value=""
                        readOnly
                      />
                      <small className="form-text">Minimum 8 characters, ideally more.</small>
                    </div>

                    <div className="mb-3">
                      <label className="form-label" htmlFor="passwordConfirmation">
                        Confirm password
                      </label>
                      <input
                        placeholder="hunter2"
                        className="form-control"
                        type="password"
                        name="passwordConfirmation"
                        id="passwordConfirmation"
                        value=""
                        readOnly
                      />
                    </div>

                    <div className="d-grid">
                      <input type="button" value="Sign up" className="btn btn-primary" disabled />
                    </div>
                  </div>
                </div>

                <div className="after-panel mt-3 mb-5 text-center">
                  Already have an account? <span>Login</span>
                  <div className="after-panel">
                    <div className="d-flex align-items-center justify-content-center text-sm mt-3">
                      <div>
                        Friends of Bettershot - 50% is powered by <span>Rewardful</span>
                      </div>
                    </div>
                  </div>
                </div>
              </UiBox>
            </Col>
          </UiBox>
        </UiBox>
      </UiBox>
    </UiTabPanel>
  );
};
